import type { PhoneInputFieldLabels } from "@a2z/ui";
import type { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";

/**
 * Localized labels for `<PhoneInputField>`. Without these, the shared
 * component falls back to its English-only defaults regardless of locale.
 */
export function getPhoneInputLabels(
  t: ReturnType<typeof useTranslations>,
): PhoneInputFieldLabels {
  return {
    countryLabel: t(keys.common.country),
    countryPlaceholder: t(keys.common.country),
    countrySearchPlaceholder: t(keys.common.countrySearchPlaceholder),
    countryNoResults: t(keys.common.countryNoResults),
    phonePlaceholder: t(keys.placeholders.phone),
  };
}
